<template>
    {{selected}}
</template>

<script lang="ts">
    import { defineComponent, ref } from "vue";

    export default defineComponent({
        props: {
            value: {
                type: Number, default: null,
            },
            code: {
                type: String, default: ""
            }
        },
        setup(props, { emit }) {
            const selected = ref("");
            const updateValue = () => {
                const { systemData } = useSystemStore();
                if (props.value)
                    selected.value = systemData.enums.find(k => k.code == props.code)?.items.find(k => k.id == props.value)?.name ?? ''
            };
            updateValue();
            watch(
                () => props.value,
                (newValue) => {
                    updateValue();
                }
            );

            return {
                selected
            };
        },
    });
</script>
